<template>
    <div class="afile-root" :style="{ width: width + 'px', height: height + 'px', top: top + 'px', left: left + 'px' }"
        @pointerdown=startDrag($event)>
        <a-file-tool ref="aFileTool" @windowResize="resizeWindow" :AFileConfig="AFileConfig" :parent-window="this">
        </a-file-tool>
        <div @mousewheel="wheelHandler" @pointerdown="onPointerDown" @pointerup="onPointerUp" @pointermove="onPointerMove" class="afile-container" :style="afileContainerStyle">
            <slot></slot>
            <canvas :ref="painterId" :id="painterId" :width="canvasWidth" :height="canvasHeight"
                :style="{ position: 'absolute', left: '0px', top: '0px', 'background-color': 'rgba(255, 0, 0, 0.00)', 'z-index': '1', 'transform-origin': 'left top' }"></canvas>
        </div>
        <slot name="toolbar"></slot>
    </div>
</template>
<script>

import PainterProxy from '@/js/painter/proxy';
import { store } from '@/store';
import dragElem from '../DragElem';
import AFileTool from './AFileTool.vue';
import { settingStore } from '../../js/store/settingStore';
import { afileBorder, afileBorderBottom } from '../../store';
import { afileStore } from '../../js/store/afileStore';
import { bookPageStore } from '../../js/store/bookPageStore';
export default {
    name: "AFileWindow",
    data: function () {
        return {
            top: 0,
            left: 0,
            width: 1457,
            height: 936,
            canvasWidth: 1393,//1856,
            canvasHeight: 856,
            painterId: 'afile-canvas-' + new Date().getTime(),
            painter: null,
            afile: null
            // deltaMouse: { x: 0, y: 0 }
        }
    },
    components: {
        AFileTool
    },
    mixins: [
        dragElem
    ],
    props: [
        "AFileConfig",
        "pageWidth",
        "pageHeight",
        "wheelHandler",
        "onPointerDown",
        "onPointerMove",
        "onPointerUp"
    ],
    computed: {
        pageSize() {
            return `${this.pageWidth}|${this.pageHeight}`
        },
        afileContainerStyle() {
            return {
                width: (this.width - afileBorder.value) + "px", 
                height: (this.height - afileBorderBottom.value) + "px",
                top: 32 + "px",
                left: 32 + "px",

            }
        }
    },
    watch: {
        pageSize: {
            handler: function () {
                this.painter.style.transform = `scale(${(this.pageWidth / this.canvasWidth)}, ${(this.pageHeight / this.canvasHeight)})`;
                this.painter.dataset.scaleX = this.pageWidth / this.canvasWidth;
                this.painter.dataset.scaleY = this.pageHeight / this.canvasHeight;
            }
        }
    },
    methods: {
        resizeWindow: function (x, y, width, height) {
            this.left = x;
            this.top = y;
            this.width = width;
            this.height = height;

            this.$emit("onChangeSize", this.width, this.height, this.$refs.aFileTool.windowScale);
        },
        setFocusPainter() {
            PainterProxy.getInstance().setCurrentPainter(this.painterId);
        },
        updateCanvasSize(width, height) {
            this.canvasWidth = width;
            this.canvasHeight = height;
        },
        maximize() {
            this.$refs.aFileTool.maximum = true;
            afileStore.maximum = true;
            bookPageStore.isHidden = true;
            this.$refs.aFileTool.resize();
        }
    },
    mounted: function () {
        // let painterSize = {
        //     width: store.globalPaintData.width - 64,
        //     height: store.globalPaintData.height - 80
        // }

        // this.canvasWidth = painterSize.width;
        // this.canvasHeight = painterSize.height;

        PainterProxy.getInstance().setPainter(this.painterId, false, true);
        PainterProxy.getInstance().setCurrentPainter(this.painterId);
        PainterProxy.getInstance().setCurrentPainterSize(this.canvasWidth, this.canvasHeight);

        this.painter = document.querySelector(`#${this.painterId}`).parentElement;
        setTimeout(() => {
            this.resizeWindow(store.globalPaintData.margin, 0, store.globalPaintData.width, store.globalPaintData.height);
            this.$refs.aFileTool.setOriginSize(store.globalPaintData.width, store.globalPaintData.height);
            if (settingStore.isFixed == 1) {
                setTimeout(() => {
                    this.resizeWindow(0, 0, store.pageWidth, store.pageHeight);
                    this.$refs.aFileTool.setOriginSize(store.pageWidth, store.pageHeight);
                });
            }
        }, 300);

        this.afile = this.$refs.afile;
    }
}
</script>
<style src="../../css/afile_styles.css"></style>
<style scoped>
.afile-container {
    position: absolute;
    /* top: 32px;
    left: 32px; */
    overflow: hidden;
    /* width: calc(100% - 64px);
    height: calc(100% - 64px); */
}
</style>